import React from 'react';

interface EditableSectionProps {
  title: string;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  children: React.ReactNode;
  hasChanges?: boolean;
}

export const EditableSection: React.FC<EditableSectionProps> = ({
  title,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  children,
  hasChanges = false
}) => {
  return (
    <div className="bg-white shadow-jobesta-card rounded-jobesta p-6 border border-jobesta-gray-40">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-jobesta-gray-90">{title}</h2>
        <div className="flex space-x-2">
          {!isEditing ? (
            <button
              onClick={onEdit}
              className="inline-flex items-center px-3 py-1.5 border border-jobesta-gray-40 text-sm font-medium rounded-jobesta text-jobesta-gray-70 bg-white hover:bg-jobesta-gray-30 hover:text-jobesta-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-jobesta-lightblue focus:ring-opacity-30 transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Edit
            </button>
          ) : (
            <>
              <button
                onClick={onSave}
                className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-semibold rounded-jobesta text-white bg-jobesta-blue hover:bg-jobesta-darkblue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-jobesta-lightblue focus:ring-opacity-30 transition-colors"
              >
                Save
              </button>
              <button
                onClick={onCancel}
                className="inline-flex items-center px-3 py-1.5 border border-jobesta-gray-40 text-sm font-medium rounded-jobesta text-jobesta-gray-70 bg-white hover:bg-jobesta-gray-30 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-jobesta-lightblue focus:ring-opacity-30 transition-colors"
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};